import { create } from 'zustand';

export enum NotificationType {
    WARNING = 'WARNING',
    ERROR = 'ERROR',
    INFO = 'INFO',
  }

interface Notification {
  id: number;
  message: string;
}

interface NotificationStore {
  notifications: Notification[];
  notificationsState: NotificationType; // מצב כללי של ההודעות
  setNotificationsState: (state: NotificationType) => void;
  addNotification: (message: string) => void;
  clearNotifications: () => void;
}

export const useNotificationStore = create<NotificationStore>((set) => ({
    notifications: [],
    notificationsState: NotificationType.INFO, // ברירת מחדל
    setNotificationsState: (state: NotificationType) =>
        set({ notificationsState: state }),
    addNotification: (message: string) =>
        set((state) => ({
            notifications: [
                ...state.notifications,
                { id: Date.now(), message },
            ],
        })),
    clearNotifications: () => set({ notifications: [], notificationsState: NotificationType.INFO }),
}));
